const visions: {
  name: string;
  imagePath: string;
  tooltip?: string;
  code: number;
  addOnPrice: number;
}[] = [
  {
    imagePath: 'https://visionhub.transitions.com/content/Lens/lens/thin.png',
    name: 'Thin',
    tooltip:
      'Thin (Polycarbonate, Anti reflective).',
    code: 1,
    addOnPrice: 25.50
  },
  {
    imagePath: 'https://visionhub.transitions.com/content/Lens/lens/thin.png',
    name: 'Thinner and Lighter',
    tooltip:
      'Thinner and Lighter (High index, Anti-Reflective).',
    code: 2,
    addOnPrice: 26.00
  }
];
export default visions;
